/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Id and name of a competition, embedded in problem reads.
 * @export
 * @interface CompetitionSummary
 */
export interface CompetitionSummary {
    /**
     * 
     * @type {string}
     * @memberof CompetitionSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitionSummary
     */
    name: string;
}

/**
 * Check if a given object implements the CompetitionSummary interface.
 */
export function instanceOfCompetitionSummary(value: object): value is CompetitionSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CompetitionSummaryFromJSON(json: any): CompetitionSummary {
    return CompetitionSummaryFromJSONTyped(json, false);
}

export function CompetitionSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function CompetitionSummaryToJSON(json: any): CompetitionSummary {
    return CompetitionSummaryToJSONTyped(json, false);
}

export function CompetitionSummaryToJSONTyped(value?: CompetitionSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

